/** @module Apparel/NewFromStyleWizard */
define([
	"dojo/_base/declare",
	"dojo/topic",
	"csi/action",
	"csi/html",
	"csi/locale",
	"csi/wizard/ActionControllerMixin",
	"csi/widget/MaterialIconWithLabel",
	"Apparel/NewFromStyle",
	"./_StyleWizardMixIn"
], function(declare, topic, csiAction, html, locale, ActionControllerMixin, MaterialIconWithLabel, NewFromStyle, _StyleWizardMixIn) {

	return declare([NewFromStyle, ActionControllerMixin, _StyleWizardMixIn], {
		idWizardResource: "NewFromStyle",

		// enable the summary indicator and the step action if configured
		isCopyingNode: true,

		/**
		 * @override
		 * configure the action for each round process of this mass operation
		 */
		getWizardStepAction: function(wizard, node) {
			return new MaterialIconWithLabel({
				className: "csi-wizard-step-action",
				icon: "delete",
				iconSize: 20,
				label: locale.resource("Discard"),
				onClick: () => {
					csiAction.invoke(wizard, wizard.domNode, this.getProxyAction("Cancel", false));

					// subtract by one after cancel/skip the current one
					this._sourceSelectedLength--;
				}
			});
		},

		/**
		 * @override
		 * hide the wizard widget before navigation to next page so that user won't see the transition
		 * also make sure correct season gets passed so themes / shapes get populated based on season availability
		 */
		onWizardViewCreate: function(wizard, page, view) {
			this.inherited(arguments);

			const index = wizard.getIndexOfPage(page);
			const hasMemoryOfHierarchy = !!this.lastCopiedUrl;

			if (index == 0 && hasMemoryOfHierarchy) {
				html.setVisible(this._popupDialog, false);

				wizard.proxyNextPage();
			} else if (index == 1) {
				view.destStructureItem = view.destStructureItem || this.getFormData().getParent();
			}
		},

		/**
		 * @override
		 * since we hide the widget during transition, so, make it visible when done
		 */
		onPostNextPage: function(wizard, page) {
			const hasMemoryOfHierarchy = !!this.lastCopiedUrl;

			if (wizard.getIndexOfPage(page) == 1 && hasMemoryOfHierarchy) {
				html.setVisible(this._popupDialog, true);

				// need to resize
				topic.publish("/csi/dialog/resize/required", true);
			}
		}
	});
});
